<script setup lang="ts">
import Normal from './components/Normal.vue'
import Advance from './components/Advance.vue'
import { onMounted, ref } from 'vue'
import type { FightRankTableType, OtherUserInfoResType, OtherUserInfoType } from '@/types/fight'
import { socketEmitAsync } from '@/utils/web-socket'
import OtherUserInfo from './components/OtherUserInfo.vue'
import Peak from './components/Peak.vue'

const envMode = import.meta.env.VITE_ENV_MODE
const localKey = `war-soul-${envMode === 'test' ? 'test-' : ''}fight-tab`

const curTab = ref('')
function handleTabChange(name: string | number) {
  localStorage.setItem(localKey, String(name))
}

const showOtherUserInfo = ref(false)
const otherUserInfo = ref<OtherUserInfoType>()
async function handleShowOtherUserInfo(row: FightRankTableType) {
  const { id: userId } = row
  const res = await socketEmitAsync<OtherUserInfoResType>({ type: 'seeUserInfo', data: { userId } })
  otherUserInfo.value = {
    nickname: row.nickname,
    nicknameColor: row.nicknameColor,
    ...res,
  }
  showOtherUserInfo.value = true
}

onMounted(() => {
  curTab.value = localStorage.getItem(localKey) || 'normal'
})
</script>

<template>
  <div class="fight-page page">
    <el-tabs v-model="curTab" stretch @tab-change="handleTabChange">
      <el-tab-pane label="普通" name="normal" class="pane">
        <Normal class="pane-item" @show-other-info="(row) => handleShowOtherUserInfo(row)" />
      </el-tab-pane>
      <el-tab-pane label="进阶" name="advance" class="pane">
        <Advance class="pane-item" @show-other-info="(row) => handleShowOtherUserInfo(row)" />
      </el-tab-pane>
      <el-tab-pane label="巅峰" name="peak" class="pane" v-if="envMode !== 'prod'">
        <Peak class="pane-item" @show-other-info="(row) => handleShowOtherUserInfo(row)" />
      </el-tab-pane>
    </el-tabs>

    <el-dialog v-model="showOtherUserInfo" width="100%" style="max-width: 500px; padding: 16px 0">
      <template v-if="otherUserInfo">
        <OtherUserInfo :userInfo="otherUserInfo" />
      </template>
      <template #footer>
        <p style="text-align: center">
          <el-button plain @click="showOtherUserInfo = false" size="small">关闭</el-button>
        </p>
      </template>
    </el-dialog>

    <FooterBar />
  </div>
</template>

<style lang="scss">
.fight-page {
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  padding-top: 15px !important;
  .world-boss {
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    position: relative;
    .help-info {
      position: absolute;
      top: 5px;
      right: 20px;
    }
  }
  .monster-extra-info {
    font-size: 12px;
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    padding: 0 5px;
  }
  .fight-res-info-wrap {
    border: 2px var(--fontColor) solid;
    border-radius: 5px;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;

    .fight-res-info {
      flex: 1;
      max-height: 100%;
      overflow: auto;
      padding: 0 20px 20px 20px;
      p {
        font-size: 14px;
        margin: 4px 0;
      }
    }
    .skill-info {
      padding-bottom: 10px;
      .cd-list {
        padding: 0 10px;
        display: flex;
        flex-flow: row nowrap;
        .item:nth-child(n + 1) {
          margin-left: 10px;
        }
      }
      .mp {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
      }
    }
  }
  .fight-btn-wrap {
    margin: 10px 0;
    display: flex;
    .main {
      flex: 1;
    }
    .hour-list {
      display: flex;
      flex-flow: column nowrap;
      button {
        width: 100%;
        margin: 4px 0;
      }
    }
  }
  .el-tabs {
    height: 100%;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    .el-tabs__content {
      flex: 1;
      .pane {
        height: 100%;
        .pane-item {
          height: 100%;
          overflow: hidden;
          display: flex;
        }
      }
    }
  }
}
</style>
